const en = {
  "RewardsEngineParam-BucketsTitle": "Average ticket ranges",
  "RewardsEngineParam-BucketsHelp":
    "The incentives engine groups clients with these ranges. Each range must start where the previous one ends.",
  "RewardsEngineParam-BucketsEmpty":
    "Incentive generation fails until average ticket ranges are saved.",
  "RewardsEngineParam-BucketMinimum": "Minimum",
  "RewardsEngineParam-BucketMaximum": "Maximum",
  "RewardsEngineParam-AddBucket": "Add range",
  "RewardsEngineParam-SaveBuckets": "Save ranges",
  "RewardsEngineParam-TypeMinimum": "Minimum value",
  "RewardsEngineParam-TypeMaximum": "Maximum value",
  "RewardsEngineParam-NoRewardTypes":
    "Create at least one incentive type before assigning values to ranges.",
  "RewardsEngineParam-BucketsSaved": "Ranges saved",
  "RewardsEngineParam-OptionalType": "optional",
  "RewardsEngineParam-RemoveBucket": "Remove range",
  "DemandForecastArtifacts-TabTitle": "Forecast",
  "DemandForecastArtifacts-Title": "Demand forecast files",
  "DemandForecastArtifacts-Description":
    "Upload the pipeline, model, and config used by each forecast for the organization.",
  "DemandForecastArtifacts-PairNote":
    "The pipeline and the model should be the pair trained together. All three files must be active; if any is missing, the run does not start.",
  "DemandForecastArtifacts-Pipeline": "Pipeline",
  "DemandForecastArtifacts-Model": "Model",
  "DemandForecastArtifacts-Config": "Config",
  "DemandForecastArtifacts-PipelineHint": "Pipeline .joblib file.",
  "DemandForecastArtifacts-ModelHint": "Model .joblib file.",
  "DemandForecastArtifacts-ConfigHint": "Config .json file.",
  "Common-CampaignTypeActivation": "Activation",
  "ActivationAction-EstimatedConversion": "Estimated conversion",
  "DemandForecastArtifacts-Upload": "Upload file",
  "DemandForecastArtifacts-UploadSuccess": "File uploaded",
  "DemandForecastArtifacts-UploadError": "Could not upload the file",
  "DemandForecastArtifacts-SetActive": "Use on the next runs",
  "DemandForecastArtifacts-SetActiveSuccess": "Active file updated",
  "DemandForecastArtifacts-Deactivate": "Stop using",
  "DemandForecastArtifacts-DeactivateSuccess": "File deactivated",
  "DemandForecastArtifacts-Active": "Active",
  "DemandForecastArtifacts-Inactive": "Inactive",
  "DemandForecastArtifacts-DeleteConfirm": "Delete this file?",
  "DemandForecastArtifacts-DeleteSuccess": "File deleted",
  "DemandForecastArtifacts-DownloadError": "Could not download the file",
  "DemandForecastArtifacts-Rename": "Rename",
  "DemandForecastArtifacts-RenameSuccess": "Name updated",
  "DemandForecastArtifacts-RenameFilename": "File name",
  "DemandForecastArtifacts-Empty": "No files yet",
  "DemandForecastArtifacts-SelectOrganizationFirst":
    "Select an organization in the header",
  "DemandForecastArtifacts-Organization": "Organization",
  "DemandForecastArtifacts-SelectionTitle": "Selection for the next run",
  "DemandForecastArtifacts-SelectionNone": "None",
  "DemandForecastArtifacts-Filename": "File",
  "DemandForecastArtifacts-Size": "Size",
  "DemandForecastArtifacts-UploadedAt": "Uploaded",
  "DemandForecastArtifacts-Status": "Status",
  "DataScienceJobs-ArtifactsUsed": "Files used",
  "DataScienceJobs-ArtifactImageDefault": "built into the image",
  "DataScienceJobs-ArtifactPipeline": "Pipeline",
  "DataScienceJobs-ArtifactModel": "Model",
  "DataScienceJobs-ArtifactConfig": "Config",
  "ImportDashboard-Title": "Import overview",
  "ImportDashboard-Description":
    "Review the latest result for each import type and browse recent history.",
  "ImportDashboard-Overview": "Overview",
  "ImportDashboard-CorrectRows": "Successful rows",
  "ImportDashboard-ErrorRows": "Rows with errors",
  "ImportDashboard-ByTypeTitle": "Latest process by import type",
  "ImportDashboard-ExpandCard": "Show details for {{type}}",
  "ImportDashboard-CollapseCard": "Hide details for {{type}}",
  "ImportDashboard-ResultSummaryCompleted":
    "Import completed: {{correct}} correct, {{errors}} errors ({{mode}})",
  "ImportDashboard-BatchMode": "batch mode",
  "ImportDashboard-BulkMode": "bulk mode",
  "ImportDashboard-Type": "Import type",
  "ImportDashboard-ProcessCount": "{{value}} historical processes",
  "ImportDashboard-LastProcess": "Latest process",
  "ImportDashboard-LastDate": "Date",
  "ImportDashboard-LastDuration": "Duration",
  "ImportDashboard-NoProcess": "There are no processes of this type yet.",
  "ImportDashboard-SourceUnavailable": "Unavailable",
  "ImportDashboard-DownloadOriginal": "Download file",
  "ImportDashboard-DownloadErrors": "Download error file",
  "ImportDashboard-DownloadFailed": "Could not download the file.",
  "ImportDashboard-VisualizeFile": "Preview latest file",
  "ImportDashboard-VisualizeTitle": "Preview: {{filename}}",
  "ImportDashboard-Action": "Action",
  "ImportDashboard-OpenImports": "Open history",
  "ImportDashboard-RecentTitle": "Recent imports",
  "ImportDashboard-File": "File",
  "ImportDashboard-Status": "Status",
  "ImportDashboard-Date": "Date",
  "ImportDashboard-ProcessedRows": "Read / total",
  "ImportDashboard-Progress": "Progress",
  "ImportDashboard-Warnings": "Warnings",
  "ImportDashboard-Search": "Search by file",
  "ImportDashboard-FilterType": "Filter by type",
  "ImportDashboard-FilterStatus": "Filter by status",
  "ImportDashboard-NoImports": "There are no imports to show.",
  "ImportDashboard-TableTotal": "{{count}} imports",
  "ImportDashboard-Refresh": "Refresh",
  "ImportDashboard-RecentScope":
    "Each card shows the latest process and historical total for its type. The table includes up to {{count}} recent processes per type.",
  "ImportDashboard-SelectBusinessUnit":
    "Select a business unit in the header to view imports.",
  "ImportDashboard-PartialError":
    "Could not load the history for {{count}} type(s). Their cards are marked unavailable.",
  "ImportDashboard-StatusCompleted": "Completed",
  "ImportDashboard-StatusProcessing": "Processing",
  "ImportDashboard-StatusError": "Error",
  "ImportDashboard-StatusCancelled": "Cancelled",
  "ImportDashboard-StatusPending": "Pending",
  "ImportDashboard-Seconds": "{{value}} sec",
  "ImportDashboard-Minutes": "{{value}} min",
  "ImportDashboard-SourceTickets": "Tickets",
  "ImportDashboard-SourceRewards": "Rewards",
  "ImportDashboard-SourceStockMovements": "Stock movements",
  "ImportDashboard-SourcePricings": "Pricing",
  "ImportDashboard-SourceClients": "Clients",
  "ImportDashboard-SourceSkus": "Articles and SKUs",
  "ImportDashboard-SourceArticleSeasons": "Article seasons",
  "ImportDashboard-SourcePaymentMethods": "Payment methods",
  "ImportDashboard-SourcePromotions": "Promotions",
  "ImportDashboard-SourcePointsMovements": "Points movements",
  "ImportDashboard-SourceBranchOffices": "Branches",
  "ImportDashboard-SourcePurchaseOrders": "Purchase orders",
  "ImportDashboard-SourceRepositionOrders": "Replenishment orders",
  "NavBar-Versions": "Versions",
  "NavBar-VersionsLoading": "Loading versions...",
  "NavBar-VersionApi": "API",
  "NavBar-VersionWeb": "Web",
  "NavBar-VersionDataScience": "Data science",
  "NavBar-VersionDataScienceShort": "DS",
};

export { en };
